module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.status),
      expression: "item.status"
    }],
    staticClass: "p-4 m-2"
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("ステータス")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.statusText))])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-faded p-4 mb-5 mt-2"
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("イベント番号")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.eventNo))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("イベント名・イベントタイトル")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.event_name))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("講師名（活動名）")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.lecturer_name) + " 先生")])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("開催日")]), _vm._v(" "), _c('pre', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.event_date))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("開催日(一覧表示用)")]), _vm._v(" "), (_vm.item.event_date_public) ? _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.event_date_public))]) : _c('pre', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.eventDatePublicMulti))]), _vm._v(" "), (!_vm.item.event_date_public) ? _c('pre', {
    staticClass: "font-weight-bold"
  }, [_vm._v("最終開催日の23:59まで掲載されます。")]) : _vm._e()]), _vm._v(" "), (_vm.item.event_date_public) ? _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("掲載終了日")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.end_date))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("開催場所・住所")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.fullAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("問い合わせ先電話番号")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.tel))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("問い合わせ先メールアドレス")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("会場ホームページ（アクセス方法）")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.homepage))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("講師ホームページ・ブログ記事URL")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.lecturer_url))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("イベントの詳細")]), _vm._v(" "), _c('pre', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.description))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("参加費")]), _vm._v(" "), _c('pre', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.fee))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("お申し込みURL")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.entry_url))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("駐車場有無")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.parking))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("撮影予定組数")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.participant))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', {
    staticClass: "mr-sm-2"
  }, [_vm._v("主催者")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.sponsor))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("主催者名")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.sponsor_name))])]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("イベント画像")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.images.filter(function (i) { return i !== ''; })), function(f) {
    return _c('image-item', {
      key: f,
      attrs: {
        "image": f
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("公開設定")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.item.published))])]), _vm._v(" "), (_vm.visibleApplyDate) ? _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("申請日")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.formatedApplyDate) + " " + _vm._s(_vm.formatedApplyDatePassed))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-3"
  }, [_c('p', [_vm._v("カテゴリ")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v("イベント")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-455e2fd6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EventDetail.vue
// module id = 82
// module chunks = 1 2